// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shopByCategoriesStyles } from "@west/App/Widgets/PopularCategories/ShopByCategories";
import { ellipsis, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

shopByCategoriesStyles.carouselSlidesContainer = {
    css: css`
        .swiper-slide {
            max-width: 144px;
        }
    `,
};

shopByCategoriesStyles.categoryCard = {
    container: {
        css: css`
            max-width: 144px;
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 18px;
        `,
    },
    image: {
        width: "144px",
        height: "144px",
        css: css`
            width: 144px;
            height: 144px;
            img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
            }
        `,
    },
    titleLink: {
        color: "text.main",
        typographyProps: {
            variant: "h5",
            forwardAs: "p",
            size: 16,
            weight: "bold",
            css: css`
                margin-bottom: 0;
                letter-spacing: 0;
                line-height: 24px;
                text-align: center;

                ${xScreen("lte", "xs")} {
                    text-align: left;
                }

                ${ellipsis(2)}
            `,
        },
        css: css`
            align-self: baseline;
            margin: 0 auto;
            ${xScreen("lte", "xs")} {
                margin: 0;
            }
        `,
    },
};
